module.exports = __webpack_public_path__ + "img/swf.260d5c48.png";